import React from 'react';
import { Sparkles, Check, Send } from 'lucide-react';
import { EField, FieldRow } from './EditableField';

export default function SectionEE({
  section_label = '', title = '', description = '', bullets = [], chat_user_msg = '', chat_ee_msg = '',
  mode = 'view', onChange,
}) {
  const set = (k) => (v) => onChange?.({ [k]: v });
  const updB = (i, v) => onChange?.({ bullets: bullets.map((b, idx) => idx === i ? v : b) });
  const addB = () => onChange?.({ bullets: [...bullets, 'New benefit'] });
  const remB = (i) => onChange?.({ bullets: bullets.filter((_, idx) => idx !== i) });

  return (
    <section className="py-24 bg-ee-bg2 relative overflow-hidden">
      <div className="absolute inset-0 bg-gold-glow-bottom pointer-events-none" />
      <div className="ee-container relative grid lg:grid-cols-2 gap-16 items-center">
        <div>
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={set('section_label')} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={set('title')} mode={mode} /></FieldRow>
              <FieldRow label="Description"><EField multiline value={description} onChange={set('description')} mode={mode} /></FieldRow>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white mb-6">{title}</h2>
              <p className="text-lg text-ee-text2 mb-8 leading-relaxed">{description}</p>
            </>
          )}
          <ul className="space-y-3">
            {bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3 group">
                <span className="mt-1 w-5 h-5 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center flex-shrink-0"><Check size={12} className="text-gold" /></span>
                <span className="text-ee-text2"><EField value={b} onChange={(v) => updB(i, v)} mode={mode} /></span>
                {mode === 'edit' && <button onClick={() => remB(i)} className="text-xs text-red-400">x</button>}
              </li>
            ))}
          </ul>
          {mode === 'edit' && <button onClick={addB} className="mt-4 text-xs px-3 py-1.5 rounded border border-gold/40 text-gold hover:bg-gold/10">+ Bullet</button>}
        </div>
        <div className="ee-card p-6 relative">
          <div className="flex items-center gap-3 pb-4 border-b border-ee-border">
            <div className="w-10 h-10 rounded-full bg-gold/10 border border-gold/40 flex items-center justify-center"><Sparkles size={16} className="text-gold" /></div>
            <div><div className="text-white text-sm font-medium">EE</div><div className="text-xs text-ee-muted">Your companion</div></div>
            <span className="ml-auto inline-block w-2 h-2 rounded-full bg-green-500" />
          </div>
          <div className="py-6 space-y-4">
            <div className="flex justify-end">
              <div className="max-w-[80%] bg-gold/10 border border-gold/30 rounded-2xl rounded-br-sm px-4 py-3 text-sm text-white">
                <EField multiline value={chat_user_msg} onChange={set('chat_user_msg')} mode={mode} />
              </div>
            </div>
            <div className="flex justify-start">
              <div className="max-w-[85%] bg-ee-card2 border border-ee-border rounded-2xl rounded-bl-sm px-4 py-3 text-sm text-ee-text2 leading-relaxed">
                <EField multiline value={chat_ee_msg} onChange={set('chat_ee_msg')} mode={mode} />
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 pt-3 border-t border-ee-border">
            <div className="flex-1 bg-ee-bg rounded-full px-4 py-2 text-sm text-ee-dim">Ask EE anything…</div>
            <button className="w-9 h-9 rounded-full bg-gold flex items-center justify-center text-black"><Send size={14} /></button>
          </div>
        </div>
      </div>
    </section>
  );
}
